// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"ae0bf3fdd8be0d72f8a6","223":"d4cede40a8ed7f235574","293":"70f711ed2817a14f149e","452":"4aa61552a03bf26f1eaa","896":"4c8c5aae1a0726cc093e"}[chunkId] + ".js";
};